var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vSelect',{attrs:{"options":_vm.organisationOptions,"reduce":(label) => label.code,"label":"label","disabled":_vm.disabled},model:{value:(_vm.organisation),callback:function ($$v) {_vm.organisation=$$v},expression:"organisation"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }